export class NeoSuspensionServicioDTO {
  constructor(
    public fechaFinSuspension: Date,
    public fechaInicioSuspension: Date,
    public idCliente: number,
    public idSuspensionServicio: number,
    public justificacion: string,
    public idUsuario: number,
    public horaInicial: string,
    public horaFinal: string,
    public fechaInicial: Date,
    public fechaFinal: Date,
  ){}
}


export interface NeoSuspensionELminarDTO {
  idSuspensionServicio: number;
  idCliente: number;
  justificacion: string;
  idUsuario: number;
}

